import { displayDate } from '../../../../../../../utils/globals/date';
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary';

export const parseExtraDataDatesNotification = (extraData: TwinDictionary) => {
    const fromDate = extraData?.from ? displayDate(new Date(extraData.from)) : undefined
    const toDate = extraData?.to ? displayDate(new Date(extraData.to)) : undefined
    const day = extraData?.day ? displayDate(new Date(extraData.day)) : undefined
    return { fromDate, toDate, day }
}